<div class="css-Archivo_agregado-1 archivo_agregado" id="comp_archivo_agregado">
    <div class="css-nombre_archivo_agregado-1 nombre_archivo_agregado">
        <p class="css-texto_nombre_archivo_agregado-1 texto_nombre_archivo_agregado"> {{ nombre }} ({{ extension }} {{
            size }})
        </p>
    </div>
    <button class="css-button_accion_eliminar_archivo-1 button_accion_eliminar_archivo" (click)="eliminarArchivo()">
        <div class="css-icono_eliminar-1 icono_eliminar">
            <img src="assets/images/vectors84071621.svg" width="10px" height="10px"
                class="css-Vector_vector-2 vector_vector">
        </div>
    </button>
</div>